import { Spinner, useToast } from '@chakra-ui/react';
import React from 'react';
import { keepPreviousData } from '@tanstack/react-query';
import ContactsTable from '../ContactsTable/ContactsTable';
import { unwrapModel } from '../../../services/api/unwrapModel';
import usePages from '../../../hooks/usePages';
import { buildPaginationFromResponse } from '../../../services/pagination';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import { getGetAllContactsQueryKey, useGetAllContacts, } from '../../../services/api/generated/client';
import { ErrorAwareAlertBox } from '../ErrorAwareAlertBox/ErrorAwareAlertBox';
import { FIVE_MIN_STALE_TIME, queryClient, } from '../../../services/api/query/queryClient';
const ContactsContent = ({ inspection, variant, onContactSelected, selectedContact, isTableInteractive, onContactDeleted, onEditContactClicked, }) => {
    const { incrementPage, decrementPage, page, setPage } = usePages();
    const toast = useToast();
    const { canEditInspection } = useInspectionDetailContext();
    const { data: response, isError, error, isFetching, } = useGetAllContacts(inspection.id, {
        should_paginate: 1,
        page,
    }, {
        query: {
            placeholderData: keepPreviousData,
            staleTime: FIVE_MIN_STALE_TIME,
        },
    });
    if (isError || error) {
        return React.createElement(ErrorAwareAlertBox, { error: error });
    }
    const contacts = unwrapModel(response);
    if (!contacts && isFetching) {
        return (React.createElement(Spinner, { size: "lg", "data-testid": "contacts_content__loading_spinner" }));
    }
    const onContactMutated = (message) => {
        if (message) {
            toast({
                title: message,
                status: 'success',
                isClosable: true,
            });
        }
        queryClient.invalidateQueries({
            queryKey: getGetAllContactsQueryKey(inspection.id),
        });
    };
    const handleContactDeleted = () => {
        setPage(1);
        onContactDeleted?.();
    };
    const pagination = buildPaginationFromResponse(response, incrementPage, decrementPage);
    return (React.createElement(ContactsTable, { selectedContact: selectedContact, inspection: inspection, onContactMutated: onContactMutated, canEditContacts: canEditInspection, isFetching: isFetching, contacts: contacts, pagination: pagination, onContactDeleted: handleContactDeleted, variant: variant, onRowClick: onContactSelected, isInteractive: isTableInteractive, onEditContactClicked: onEditContactClicked }));
};
export default ContactsContent;
